import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NewOrderComponent } from '../new-order.component';

@Component({
    selector: 'app-new-search',
    templateUrl: './new-search.component.html',
    styleUrls: ['./new-search.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewSearchComponent extends NewOrderComponent {

}
